import React from "react";
import { Chip } from "@material-ui/core";

const FilterChip = ({
    filter,
    filters,
    filterName,
    onChange,
    toggleFilter,
    icon,
    label,
}) => {
    const isAll = filter.value === "all";

    const isSelected = isAll
        ? filters[filterName].length === 0
        : filters[filterName].includes(filter.value);

    const handleClick = () => {
        if (isAll) {
            onChange({
                ...filters,
                [filterName]: [],
            });
        } else {
            toggleFilter(filterName, filter.value);
        }
    };

    return (
        <Chip
            icon={icon}
            label={label}
            clickable
            color={isSelected ? "primary" : "default"}
            onClick={handleClick}
        />
    );
};

export default FilterChip;